<template>
  <v-card class="ma-4">
    <v-card-text>
      <v-container>
        <v-row justify="center">
          <v-col sm="12" md="11">
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title class="headline">
                  <BatchNavigation :instance="batch" />
                </v-toolbar-title>
                <v-spacer />
                <QualityCoatedMeasurementForm
                  :is-duplicate="false"
                  :is-edit="false"
                  :batchid="batch.id"
                >
                </QualityCoatedMeasurementForm>
              </v-toolbar>
              <QualityCoatedMeasurementTable
                :batchid="batchid"
                :is-detailed="true"
                :measurements="batch.measurements"
                :loading="loading"
              />
            </v-card>
          </v-col>
          <v-col sm="12" md="10">
            <v-card>
              <v-card-title class="subtitle-2">
                <v-icon left>grain</v-icon>
                Composition of Batch {{ batch.forgeID }}
              </v-card-title>
              <BatchRawOriginTable
                :is-detailed="false"
                :batchid="parseInt(batch.id)"
                :loading="loading"
                :items="batch.composition"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import BatchRawOriginTable from "../Batch/BatchRawOriginTable";
import QualityCoatedMeasurementTable from "./QualityCoatedMeasurementTable";
import QualityCoatedMeasurementForm from "./QualityCoatedMeasurementForm";
import Batch from "../../models/Batch";
import BatchNavigation from "../Batch/BatchNavigation";
export default {
  name: "QualityCoatedMeasurementWrapper",
  components: {
    BatchNavigation,
    QualityCoatedMeasurementTable,
    BatchRawOriginTable,
    QualityCoatedMeasurementForm
  },
  props: {
    batchid: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    // There's some kind of bug here that requires uses the with chain instead of withAllRecursive
    batch() {
      return Batch.query()
        .with("measurements.batch")
        .with("composition.rawmaterial")
        .find(parseInt(this.batchid));
    }
  },
  methods: {
    initialize() {
      this.loading = true;
      Batch
        .$get(this.batchid)
        .then(() => this.loading = false)
    }
  }
};
</script>
